export default __webpack_public_path__ + "static/media/registration-successfull.a05f0fd5.png";